module.exports = __webpack_public_path__ + "static/media/news.6b08a30d.png";